import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV_LINKS, UPWORK } from "../data/site";
import { scrollToId } from "../lib/scroll";
import { WORKFLOX } from "../data/workflox";
import { WorkfloxLink } from "./home/Chrome";
import "../styles/site.css";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      // The home page loops: its last screen is a copy of the first, so the bar
      // clears there just as it does at the top and the wrap-around is seamless
      const end = document.documentElement.scrollHeight - window.innerHeight;
      setScrolled(y > 24 && !(pathname === "/" && y > end - 24));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  // On the home page scroll directly; elsewhere the /#id link lands on home first
  const handleSection = (id) => (e) => {
    if (pathname === "/") {
      e.preventDefault();
      scrollToId(id);
    }
  };

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="nav-inner">
        <Link to="/" className="nav-logo" onClick={handleSection("hero")}>
          Sami<span>.</span>
        </Link>
        <nav className="nav-links" aria-label="Main">
          {NAV_LINKS.map(({ id, label }) => (
            <Link key={id} to={`/#${id}`} className="nav-link" onClick={handleSection(id)}>
              {label}
            </Link>
          ))}
          <WorkfloxLink href={`${WORKFLOX}/blog`} className="nav-link">
            Blog
          </WorkfloxLink>
          <a href={UPWORK} target="_blank" rel="noopener noreferrer" className="btn btn--solid">
            Hire me
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
